import { CommonModule, DatePipe } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FormErrorsComponent } from 'src/app/components/form-errors/form-errors.component';
import { AddSkills } from 'src/app/models/skills/skills';
import { SkillsService } from 'src/app/services/skills.service';

@Component({
  selector: 'app-skills-modal',
  imports: [CommonModule, ReactiveFormsModule, FormErrorsComponent, MatDialogContent, MatDialogActions, MatDialogTitle],
  templateUrl: './skills-modal.component.html',
  styleUrls: ['./skills-modal.component.css']
})
export class SkillsModalComponent implements OnInit{
  form: FormGroup = new FormGroup({});

  constructor(
    private fb: FormBuilder,
    public datePipe: DatePipe,
    public dialogRef: MatDialogRef<SkillsModalComponent>,
    public SkillsService: SkillsService,
    public _toastService: ToastrService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any    
  ) {
    
    this.buildForm();

    if(this.data?.item){
      this.form.patchValue({...this.data?.item}); 
    }
    if(this.data?.view){
      this.form.disable();
    }

  } 

  ngOnInit(): void {
    
  }

  private buildForm(){
    this.form = this.fb.group({
          id: new FormControl(0),
          name: new FormControl('', [Validators.required, Validators.maxLength(1000)]),
          isEnabled: new FormControl(true),
          softSkill: new FormControl(false)
    })
  }

  Accept() {
   
    const SkillsModel = this.form?.value as AddSkills;
    
    if(this.form.invalid) {
      this.form.markAllAsTouched();
      this._toastService.error("Por favor, complete todos los campos requeridos.");
      return;
    }
    
    if(this.data.mode == 'add' || this.data.mode == 'edit'){         
      this.save(SkillsModel);  
    }else if(this.data.mode == 'delete'){
      this.delete(SkillsModel.id!);
    }
  }
  save(SkillsModel: AddSkills){    
    this.SkillsService.addSkills(SkillsModel).subscribe({
      next: (res:any) => {
        if(!res){this._toastService.error("Ha ocurrido un error inesperado"); return}        
        this._toastService.success("Datos guardados")
        this.closeDialog()
      }, error: (error: any) => {this._toastService.error('Ha ocurrido un error inesperado')}
    })
  }
  delete(id: number){    
    this.SkillsService.deleteSkills(id).subscribe({
      next: (res:any) => {
        if(!res){this._toastService.error("Ha ocurrido un error inesperado"); return}        
        this._toastService.success("Datos eliminados correctamente!")
        this.closeDialog()
      }, error: (error: any) => {this._toastService.error('Ha ocurrido un error inesperado')}
    })
  }

  closeDialog(): void {
    this.dialogRef.close(true);
  }

}
